<template>
<div>
  <van-cell-group class="fromList">
    <!-- input -->
    <van-field
      v-if="msg.attr_code == 'chinese'"
      v-model="msg.value "
      maxlength= '20'
      :required="msg.is_not_null == 1 ? true : false "
      clearable
      :label="msg.field_name"
      :placeholder="msg.place_holdor"
    />
     <div v-if="msg.attr_code == 'paragraph'" :style="{ color: activeColor, fontSize: '0.3rem',fontWeight:'800',background: '#f6f6f6',padding: '0.3rem'}" >
      {{msg.field_name}}
    </div>
    <!-- 性别弹出框 -->
    <div v-if="msg.attr_code == 'radio'">
      <van-field
        readonly
        :required="msg.is_not_null == 1 ? true : false "
        clickable
        :label="msg.field_name"
        :value="msg.value"
        :placeholder="msg.place_holdor"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="msg.attr_setting.option"
          @cancel="showPicker = false"
          @confirm="onConfirm"
        />
      </van-popup>
  </div>
    <!-- checkbox -->
  <div v-if="msg.attr_code =='checkbox'" class="check">
    <van-checkbox-group v-model="msg.value" @change="checkChange">

      <van-cell-group>
            <p class="checkTitle">{{msg.field_name}}</p>
        <van-cell
          v-for="(item, index) in msg.attr_setting.option"
          clickable
          :key="item"
          :title="item"
          @click="toggle(index)"
        >
          <van-checkbox
            :name="item"
            ref="checkboxes"
            slot="right-icon"
          />
        </van-cell>
      </van-cell-group>
    </van-checkbox-group>
  </div>
    <!-- textarea -->
    <!-- <van-field
      v-if="msg.attr_code == 'description'"
      v-model="msg.attr_setting.text"
      readonly	
      :autosize= "{maxHeight:400, minHeight:21}"
      :style="fontColor" 
      :required="msg.is_not_null == 1 ? true : false "
      type ="textarea"
    /> -->


       <van-field
      v-if="msg.attr_code == 'textarea'"
      v-model="msg.value"
     autosize
      :label="msg.field_name"
      :value="msg.type_name"
      :placeholder="msg.place_holdor"
      :style="fontColor" 
      :required="msg.is_not_null == 1 ? true : false "
      type ="textarea"
    />

     <!-- <van-field
      v-if="msg.attr_code == 'description'"
      v-model="msg.value"
      :required="msg.is_not_null == 1 ? true : false "
      clearable
      :value="msg.value"
     
      :label="msg.field_name"
      :placeholder="msg.place_holdor"
    /> -->
    <div  v-if="msg.attr_code == 'description'" class="formTextarea" :style="fontColor">
      {{msg.attr_setting.text}}
    </div>
    <!-- 身份证 -->
    <van-field
      v-if="msg.attr_code == 'idCard'"
      v-model="msg.value"
      :required="msg.is_not_null == 1 ? true : false "
      clearable
      maxlength= '18'
      :label="msg.field_name"
      :placeholder="msg.place_holdor"
    />

    <!-- phone -->
    <van-field
      v-if="msg.attr_code == 'mobile'"
      v-model="msg.value"
      :required="msg.is_not_null == 1 ? true : false "
      type ="number"
      clearable
      maxlength= '11'
      :label="msg.field_name"
      :placeholder="msg.place_holdor"
    />
    
    <!-- password -->
    <div v-if="msg.attr_code == 'password'">
      <van-field
        v-model="msg.value"
        v-if="passShow"
        :required="msg.is_not_null == 1 ? true : false "
        type ="password"
        :right-icon="yanjng1"
        maxlength= '20'
        :label="msg.field_name"
        @click-right-icon="passChange"
        :placeholder="msg.place_holdor"
      />
      <van-field
        v-model="msg.value"
        v-else
        :required="msg.is_not_null == 1 ? true : false "
        maxlength= '20'
        :right-icon="yanjng"
        :label="msg.field_name"
        @click-right-icon="passChange"
        :placeholder="msg.place_holdor"
      />
    </div>


    <!-- number -->
    <van-field
      v-if="msg.attr_code == 'number'"
      v-model="msg.value"
      :required="msg.is_not_null == 1 ? true : false "
      type ="number"
      clearable
      maxlength= '20'
      :label="msg.field_name"
      :placeholder="msg.place_holdor"
    />

    <!-- 选择省、市、镇 -->
    <div v-if="msg.attr_code == 'region'">
      <van-field
        readonly
        :required="msg.is_not_null == 1 ? true : false "
        clickable
        v-model="city"
        :label="msg.field_name"
        :value="region"
        :placeholder="msg.place_holdor"
        @click="showArea = true"
      />
      <van-popup v-model="showArea" position="bottom">
          <van-area :area-list="areaList" @cancel="showArea = false" @confirm="sureArea"  title="省、市、区"/>
      </van-popup>
  </div>

    <!-- 日期格式 ，年月日 -->
    <div v-if="msg.attr_code == 'date'">
      <van-field
        readonly
        :required="msg.is_not_null == 1 ? true : false "
        clickable
        v-model="msg.value"
        :label="msg.field_name"
        :placeholder="msg.place_holdor"
        @click="dataShow = true"
      />
      <van-popup v-model="dataShow" position="bottom">
        <van-datetime-picker v-model="datas" type="date" @cancel="dataShow = false" @confirm="sureData"/>
      </van-popup>
  </div>
   <!-- 日期格式 完整时间 年月日时分秒-->
  <div v-if="msg.attr_code == 'datetime'">
      <van-field
        readonly
        :required="msg.is_not_null == 1 ? true : false "
        clickable
        v-model="msg.value"
        :label="msg.field_name"
        :placeholder="msg.place_holdor"
        @click="dataTimeShow = true"
      />
      <van-popup v-model="dataTimeShow" position="bottom">
        <van-datetime-picker v-model="dataTime" type="datetime" @cancel="dataTimeShow = false" @confirm="sureDataTime"/>
      </van-popup>
  </div>
    <div v-if="msg.attr_code == 'file' && uploadDisabled "  class="upload">
       <p class="checkTitle"><span :class="{'iconRed':msg.is_not_null == 1}">*</span>{{msg.field_name}}</p>
      <van-uploader  accept upload-text="文件上传" :max-count="1" multiple  :before-read="beforeRead">
        <van-button icon="photo" type="primary">{{msg.field_name}}</van-button>
      </van-uploader>
    </div>
  </van-cell-group>  
    <div v-if="msg.attr_code == 'image' && uploadDisabled"  class="uploadImg">
      <p class="checkTitle"><span :class="{'iconRed':msg.is_not_null == 1}">*</span>{{msg.field_name}}</p>
   
   <!-- <div v-for="(item,index) in fileList.value" :key='index'> -->
     <!-- :deletable="false" :show-upload="false"  -->
    
      <van-uploader  :upload-text="msg.place_holdor" :max-count="fileNmberLimit" :preview-image="true" 
      v-model="fileList" multiple  :before-read="beforeImg" :after-read="onRead"   :before-delete="deleteimg">
        
      </van-uploader>
    <!-- </div> -->
</div>

<!-- 爱好弹出框 -->
     
      <div  v-if="msg.attr_code == 'manySelect'">
        <van-field 
       
          readonly
          clickable
          :required="msg.is_not_null == 1 ? true : false "
          v-model="aihaonameone"
          :label="msg.field_name"
          :value="msg.type_name"
          :placeholder="msg.place_holdor"
          @click="showPickeraihao = true"
        />
        
        <van-popup v-model="showPickeraihao" position="bottom">
          
          <van-picker
            show-toolbar
            value-key="name"
            :columns="msg.attr_setting.option"
            @cancel="showPickeraihao = false"
            @confirm="aihaoonConfirm"
          />
        
        </van-popup>
    </div>

<!-- || msg.value.length>=2 -->
     <div v-if="msg.attr_code == 'manySelect' || firstcount.length>0 ">
      
        <van-field 
        
          readonly
          clickable
          :required="firstcount.length>0 ? true : false "
          v-model="aihaonametwo"
          label="二级分类"
          :value="msg.type_name"
          placeholder="请选择二级分类"
          @click="showPickerone = true"
        />
        <van-popup v-model="showPickerone" position="bottom">
          
          <van-picker
            show-toolbar
            value-key="name"
            :columns="firstcount"
            @cancel="showPickerone = false"
            @confirm="oneonConfirm"
          />
        
        </van-popup>
    </div>



    <div v-if="msg.attr_code == 'manySelect' || secondcount.length>0 ">
       <!-- :label="msg.field_name" -->
        <van-field 
        
          readonly
          clickable
          :required="secondcount.length ? true : false "
          v-model="aihaonamethree"
         label="三级分类"
          :value="msg.type_name"
          placeholder="请选择三级分类"
          @click="showPickerthree = true"
        />
        <van-popup v-model="showPickerthree" position="bottom">
          <van-picker
            show-toolbar
            value-key="name"
            
            :columns="secondcount"
            @cancel="showPickerthree = false"
            @confirm="threeonConfirm"
          />
        
        </van-popup>
    </div>



  
</div>
</template>

<script>
import  areaList  from '@/assets/js/area.js'
import yanjng from '@/assets/yanjing.png';
import yanjng1 from '@/assets/yanjing_1.png';
import { mapGetters, mapMutations } from 'vuex';
import { put } from '@/utils/index.js'
export default {
  components: {
    areaList
  },
  name: 'HelloWorld',
  props: {
    msg:{
      type: Object,
      default: {},
      }
  },
  beforeCreate(){
      this.areaList= {};
  },
  created(){
    if(this.msg.attr_code == 'idCard'){
      this.SET_IDCARD(this.msg.value)
    }
    if(this.msg.attr_code == 'region'){
      this.sureArea(this.msg.value);
      Object.assign(this.areaList, areaList)
      if(this.msg.attr_setting.provinceScope > 0 ){
        this.eachCity(this.msg.attr_setting.provinceScope)
      }else {
      }
    }
    if(this.msg.attr_code == 'image'){
  
      for(var i=0;i<this.msg.value.length;i++){
        this.fileList.push({url: this.msg.value[i], isImage: true});
       
      }
      this.fileNmberLimit =Number(this.msg.attr_setting.fileNumberLimit);
      this.singleFileSizeLimit = this.msg.attr_setting.singleFileSizeLimit;
     
    }
 if(this.msg.attr_code=='manySelect'){
        this.mynewopti=this.msg.attr_setting.option
        console.log( this.mynewopti)
        this.aihaonametwo=this.msg.value[1]
       this.aihaonameone=this.msg.value[0]
       this.aihaonamethree=this.msg.value[2]
     }
    this.msg.type_name = '';
  },
  mounted(){
    if(this.idCard.length ==  18){
      this.uploadDisabled = true;
    }

    
  },
  data(){
    return {
       aihaonametwo:'',
      aihaonameone:'',
      aihaonamethree:'',
       mynewopti:[],
      firstcount:[],
      secondcount:[],
       showPickerone:false,
      showPickerthree:false,
      showPickeraihao:false,
      newvalueto:[],
      // idCard:'', // 身份证
      attr_setting:'', //汉字
      mobile: '', // 手机号
      password: '', // 密码
      number: '', // 数字
      result:[],
      list:[ //复选框数据
        {item:'复选框1', key:1},
        {item:'复选框2', key:2}
      ],
      datas: new Date(),// 的年月日 日期数据 初始数据
      dataShow: false, // 选择日期弹层
      radio:'', // 性别选定数据
      columns: ['男', '女'], // 下拉数据
      showPicker: false, //性别 弹层show
      description:'', // 文字说明
      showArea: false, // 省市区弹层
      region: '', // 省市区选定数据
      areaList: {}, // 省市区数据列表
      dataTimeShow: false,
      dataTime: new Date(),// 年月日时分 日期数据  初始数据
      city: '', // 城市回显
      fileList:[], //图片回显
      fileNmberLimit:'', // 最大上传文件个数
      singleFileSizeLimit:'', // 最大上size
      uploadDisabled: false, // 上传禁用
      passShow: true, // 密码框切换
      yanjng, //密码显示 眼睛iocn
      yanjng1, //密码显示 眼睛iocn
      fontColor:{
        color:this.msg.attr_setting.color
      }, // 字体颜色
       activeColor:this.msg.attr_setting.color,
      newfileList:[],
      asd:[],
    }
  },
  methods:{
  /**
   * vuex 辅助函数
   * @method mapMutations
   */
  ...mapMutations(
      'app', ['SET_IDCARD',]
  ),
    toggle(){

    },
    /**
     * 性别选择方法 
     * @method onConfirm
     * 当前选择的性别 数据
     * @param sexs
     */
    onConfirm(sexs) {
      this.msg.value = sexs;
      this.showPicker = false;
    },
    /**
     * 爱好
     * @method onConfirm
     * 当前选择的性别 数据
     * @param sexs
     */
    aihaoonConfirm(sexs,index) {
      this.msg.type_name=sexs.name
      this.aihaonameone = sexs.name;
       this.aihaonamethree =''
        this.aihaonametwo =''
      // console.log('当前值1' + sexs.name + '当前索引' + sexs.code);
       this.numberlist(this.msg.template_field_id , 0, this.aihaonameone);
      let that=this
            for(var i=0;i<that.mynewopti.length;i++){
              if(that.mynewopti[i].name==sexs.name){
                  that.firstcount=that.mynewopti[i].child
                    // console.log( that.firstcount)
              }
          }
      this.showPickeraihao = false;
    },
    numberlist(id,index,value){
      //是否变量存在
      if(!this.newvalueto[id]){
        this.newvalueto[id] = [];
      }
      //值是否相等
      if(this.newvalueto[index] == value){
        return true;
      }
      this.newvalueto[id][index] = value;
      //删除index以后的值
      this.newvalueto[id].splice(index+1,this.newvalueto[id].length);
       this.msg.value=this.newvalueto[id]
         this.msg.type_name=this.newvalueto[id]
      console.log(this.newvalueto[id]);

      // return true
    },
    oneonConfirm(sexs,index){
      this.msg.type_name=sexs.name
      this.aihaonametwo = sexs.name;
       this.aihaonamethree =''
      
      this.numberlist(this.msg.template_field_id , 1 , this.aihaonametwo);
      
        let that=this
              for(var i=0;i<that.firstcount.length;i++){
                if(that.firstcount[i].name==sexs.name){
                    that.secondcount=that.firstcount[i].child
                      console.log( that.secondcount)
                 
                }
            }
      this.showPickerone = false;   
    },
    threeonConfirm(sexs,index){
     this.msg.type_name=this.msg.value
      
      this.aihaonamethree = sexs.name;
     this.numberlist(this.msg.template_field_id , 2, this.aihaonamethree);
  
      this.showPickerthree = false;   
    },
    /**
     * 选择 城镇方法回调函数
     * @method sureArea
     * 当前选择的 省、市、镇 数据
     * @param item
     */
    sureArea(item){
      if(item[0].code == 100000){
        this.$toast('请选择省、市、区')
        return false;
      }
      this.city = '';
      this.msg.value = [];
      item.forEach(el => {
        this.city = `${this.city}  ${el.name}`
        this.msg.value.push(el.code);
      });
      this.showArea = false;
    },
    /**
     * 时间格式转换方法
     * @method checkTime
     * 月 日
     * @param item
     */
    checkTime(item){
        item < 10 ? item = '0'+ item : null;
        return item
    },
    /**
     * 选择年月日 日期回调函数
     * @method sureData
     * 当前选择的 年、月、日数据
     * @param item
     */
    sureData(item){
      let date= new Date(item)
      this.msg.value = date.getFullYear()+'-'+this.checkTime(date.getMonth()+1)+'-'+this.checkTime(date.getDate());
      this.dataShow = false;
    },
    /**
     * 获取完整时间
     * @method sureDataTime
     * 当前选择的时间
     * @param item
     */
    sureDataTime(item){
      let date = new Date(item)
      this.dateTimeInput = date.getFullYear()+'-'+this.checkTime(date.getMonth()+1)+'-'+this.checkTime(date.getDate())+' '+this.checkTime(date.getHours()) + ':' + this.checkTime(date.getMinutes()) + ':' + this.checkTime(date.getSeconds());
      this.msg.value = date.getFullYear()+'-'+this.checkTime(date.getMonth()+1)+'-'+this.checkTime(date.getDate())+' '+this.checkTime(date.getHours()) + ':' + this.checkTime(date.getMinutes()) + ':' + this.checkTime(date.getSeconds());
      this.dataTimeShow = false;
    },
    /**
     * 循环城市
     * @method eachCity
     */
    eachCity(item){
      let city = this.areaList.province_list[item];
      let obj = {
        [item] : city
      }
      this.areaList.province_list = {
        100000:'请选择',
        [item] : city
      };
      
    },
    /**
     * checkbox chang事件
     * @method checkChange
     */
    checkChange(item){
      this.msg.value = item;
    },
    /**
     * 上传文件 提交方法
     * @method beforeRead
     */
    beforeRead(file){
      if(file.size > 10000000){
        this.$toast.fail('文件大小不能超过10m');
        return false;
      }
      put(file,'excellent_file_').then( res => {
        this.msg.value = [];
        this.msg.value.push(res.url)
      })
      return 
    },
    /**
     * 上传图片 提交方法
     * @method beforeRead
     */
    beforeImg(file){
      // if(file.size > (Number(this.singleFileSizeLimit)*1000000)){
      //   this.$toast.fail('文件大小不能超过1m');
      //   return false;
      // }
      //       put(file,'excellent_image_').then( res => {
      //         this.msg.value = [];
      //         this.msg.value.push(res.url)
      //         this.fileList.push({url:res.url,  isImage: true});
      //       })
      // return 


       let regex = /(.jpg|.jpeg|.png|.bmp)$/
      if (!regex.test(file.type)) {
        this.$toast.fail('图片格式不支持上传')
        return false
      } else {
        return true
      }
    },
     onRead (file){
       this.asd=this.msg.value
       console.log(this.msg.value)
        
      let that=this
     
        if(file.file.size > (Number(that.singleFileSizeLimit)*1000000)){
         
          let canvas = document.createElement('canvas') // 创建Canvas对象(画布)
        let context = canvas.getContext('2d')
        let img = new Image()
        img.src = file.content // 指定图片的DataURL(图片的base64编码数据)
        img.onload = () => {
          canvas.width = 400 
          canvas.height = 300
          context.drawImage(img, 0, 0, 400, 300)
          file.content = canvas.toDataURL(file.file.type, 0.92) // 0.92为默认压缩质量
          // let files = that.dataURLtoFile(file.content, file.file.name)
          // const data = new FormData()
          // data.append('file', files)
          
          put(file.file,'excellent_image_').then( res => {
             
              //  方法1
              // that.fileList.push({url:res.url,  isImage: true});
              // this.fileList=that.asd
              //  that.msg.value= that.fileList
              
               // 方法二
               that.newfileList.push({url:res.url,  isImage: true});
              that.fileList=that.newfileList
                that.asd =[]
                //  that.asd=this.msg.value
               for(var i=0;i<that.fileList.length;i++){
                  if(that.fileList[i].url){
                    
                    that.asd.push(that.fileList[i].url)
                  }
               }
              that.msg.value=  that.asd
            })
        }
      }
      else { //小于10M直接上传
        put(file.file,'excellent_image_').then( res => {
            //  方法1
              // that.fileList.push({url:res.url,  isImage: true});
              // that.fileList.push(res.url);
              // that.msg.value= that.fileList
            //  debugger
              // 方法二
               that.newfileList.push({url:res.url,  isImage: true});
              that.fileList=that.newfileList
               that.asd =[]
              // that.asd=that.msg.value
               for(var i=0;i<that.fileList.length;i++){
                  if(that.fileList[i].url){
                    that.asd.push(that.fileList[i].url)
                  
                  }
               }
                that.msg.value=  that.asd
            
            })
       
      }
    },
      // 删除图片
    deleteimg(index){
      let that=this
      
          for (let i = 0; i< this.fileList.length;  i++) {
             
           if (that.fileList[i].url== index.url) {  
              that.fileList.splice(i,1)
            
           }
            that.asd.push(that.fileList[i].url)
           that.msg.value= that.asd
          }


          for(var i=0;i<that.asd.length;i++){
                  if(that.asd[i]==index.url){
                     that.asd.splice(i,1)
                     that.msg.value= that.asd
                   
                  }
               }
         
    },
    /**
     * 密码显示方法
     * @method passChange
     */
    passChange(event){
      this.passShow = !this.passShow;
      console.log(this.passShow)
    }
  },
  watch:{
      idCard(val){
        if(this.msg.attr_code == 'image' || this.msg.attr_code == 'file' ){
            val.length == 18 ? this.uploadDisabled = true : this.uploadDisabled = false;
        }
      },
      newValue(val){
        this.msg.attr_code == 'idCard' ? this.SET_IDCARD(val) : null;
      }
  },
  computed: {
    ...mapGetters([
          'idCard',
    ]),
　　newValue() {
　　　　return this.msg.value
　　}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.checkTitle{
  text-align: left;
  font-size: 14px;
  color: #323233;
  padding: 10px 16px 0px 16px;
}
.upload{
  display: flex;
  align-items: center;
  padding-bottom: 17px;
}
.uploadImg{
  display: flex;
  align-items: center;
  padding-bottom: 10px;
  padding-top: 10px;
  .van-uploader__upload-text{
    text-align: center;
  }
}
.iconRed{
  color: red;
}
.iconF{
  color: #fff;
}
.formTextarea{
  min-height: 24px;
  line-height: 24px;
  padding: 10px 16px;
  font-size: 14px;
}
</style>
